import { Flex, Card, ButtonGroup } from "@wayflyer/flyui";
import { styled } from "styled-components";

import { type PlatformConnection, PlatformConnectionList } from "../../platform-connection-list";

const StyledCard = styled(Card)`
  border: 1px solid var(--palette-border-neutral-subtle);
`;

export interface ShowConnectionsProps {
  onComplete: () => void;
  onConnectAnother: () => void;
  connections?: PlatformConnection[];
}

export interface ShowConnectionsConfig {
  title: string;
  description?: string;
  connectMoreLabel: string;
  finishedLabel: string;
}

/**
 * ShowConnections component
 *
 * @deprecated
 */
export const ShowConnections = ({
  onComplete,
  onConnectAnother,
  connections,
  title,
  description,
  connectMoreLabel,
  finishedLabel,
}: ShowConnectionsProps & ShowConnectionsConfig): UIElement => {
  return (
    <StyledCard padding="large" slots={{ header: <Card.Header title={title} subtitle={description} /> }}>
      <Flex direction="column" gap="6">
        {connections && connections.length > 0 && <PlatformConnectionList connections={connections} />}
        <ButtonGroup
          primaryAction={{
            content: finishedLabel,
            onAction: onComplete,
            analyticsId: "finished-button",
          }}
          secondaryAction={{
            content: connectMoreLabel,
            onAction: onConnectAnother,
            analyticsId: "connect-button",
          }}
          primaryActionTestId="finished-button"
          secondaryActionTestId="connect-button"
        />
      </Flex>
    </StyledCard>
  );
};
